import en from './deleteTenantEn';

function ip(s, v) {
  if (!s || !v) return s || '';
  return s.replace(/\{\{(\w+)\}\}/g, (_, k) => (v[k] != null ? String(v[k]) : ''));
}

const de = {
  ...en,
  sectionTitle: 'Mandant löschen',
  sectionSubtitle: 'Diesen Mandanten und alle zugehörigen Daten endgültig entfernen',
  introPermanent: 'Das Löschen eines Mandanten ist',
  introIrreversible: 'dauerhaft und nicht rückgängig zu machen',
  introSuffix: '. Alle Mandantendaten werden endgültig entfernt, u. a.:',
  listRoles: 'Rollen und Rollenzuordnungen',
  listUsers: 'Benutzer und Zuweisungen',
  listResources: 'Ressourcen und Konfigurationen',
  listSessions: 'Sitzungen und Authentifizierung',
  listKnowledge: 'Wissensdatenbank und Dokumente',
  listOther: 'Sonstige mandantenspezifische Daten',
  requirementNote:
    'Nur möglich, wenn der Mandant keine Kostenstellen und keine aktiven bezahlten Ressourcen hat.',
  eligible: 'Mandant kann gelöscht werden',
  notEligible: 'Mandant kann nicht gelöscht werden',
  eligibilityDetails: 'Voraussetzungen',
  tenantAdmin: 'Mandanten-Admin:',
  costPools: 'Kostenstellen:',
  activePaidResources: 'Aktive bezahlte Ressourcen:',
  blockedBecause: 'Gesperrt, weil:',
  checkEligibility: 'Prüfen',
  checking: 'Prüfe…',
  beforeCheckHint:
    'Führen Sie zuerst die Prüfung aus. Wenn sie erfolgreich ist, erscheint hier die Schaltfläche zum endgültigen Löschen.',
  eligibleNextStep:
    'Die Prüfung war erfolgreich. Nutzen Sie die Schaltfläche unten, um den Mandanten endgültig zu löschen.',
  recheckEligibility: 'Erneut prüfen',
  deleteTenantCta: 'Mandanten endgültig löschen',
  deleteTenant: 'Mandant löschen',
  deleting: 'Lösche…',
  confirmTitle: 'Endgültiges Löschen bestätigen',
  cannotUndone: 'Nicht rückgängig zu machen',
  typeDeletePrompt: 'Zur Bestätigung bitte',
  typeDeletePromptAfter: 'in das Feld eintragen.',
  placeholderDelete: 'DELETE eingeben',
  cancel: 'Abbrechen',
  deletePermanently: 'Endgültig löschen',
  loadFailed: 'Kostenstellen konnten nicht geladen werden',
  loadError: 'Fehler beim Laden: {{message}}',
  backToTenant: '← Zurück zum Mandanten',
  costPoolsTitle: 'Kostenstellen',
  loading: 'Laden…',
  loadingCostPools: 'Kostenstellen werden geladen…',
  errorTitle: 'Fehler beim Laden',
  retry: 'Erneut',
  thName: 'Name',
  thBudget: 'Budget',
  thSpent: 'Ausgegeben',
  thRemaining: 'Verbleibend',
  thPayment: 'Zahlungsmittel gültig',
  thActions: 'Aktionen',
  yes: 'Ja',
  no: 'Nein',
  view: 'Ansehen',
  noPoolsTitle: 'Keine Kostenstellen',
  noPoolsBody: 'Dieser Mandant hat noch keine Kostenstellen.',
  addCostPool: 'Kostenstelle anlegen',
};

const MAP = {
  en,
  de,
  es: { ...en, sectionTitle: 'Eliminar inquilino', cancel: 'Cancelar', retry: 'Reintentar' },
  fr: { ...en, sectionTitle: 'Supprimer le locataire', cancel: 'Annuler' },
  it: { ...en, sectionTitle: 'Elimina tenant', cancel: 'Annulla' },
  pt: { ...en, sectionTitle: 'Eliminar inquilino', cancel: 'Cancelar' },
  nl: { ...en, sectionTitle: 'Tenant verwijderen', cancel: 'Annuleren' },
  pl: { ...en, sectionTitle: 'Usuń najemcę', cancel: 'Anuluj' },
  sv: { ...en, sectionTitle: 'Ta bort tenant', cancel: 'Avbryt' },
  no: { ...en, sectionTitle: 'Slett leietaker', cancel: 'Avbryt' },
  da: { ...en, sectionTitle: 'Slet lejer', cancel: 'Annuller' },
  fi: { ...en, sectionTitle: 'Poista vuokralainen', cancel: 'Peruuta' },
  cs: { ...en, sectionTitle: 'Smazat tenanta', cancel: 'Zrušit' },
  hu: { ...en, sectionTitle: 'Bérlő törlése', cancel: 'Mégse' },
  ro: { ...en, sectionTitle: 'Șterge tenant', cancel: 'Anulare' },
  el: { ...en, sectionTitle: 'Διαγραφή μισθωτή', cancel: 'Ακύρωση' },
  id: { ...en, sectionTitle: 'Hapus tenant', cancel: 'Batal' },
};

export function getDeleteTenantStrings(lang) {
  return MAP[lang] || en;
}
export { ip };
